export const movieMenuData = ['popular', 'now playing', 'top rated']

export const tvMenuData = ['popular', 'now playing', 'top rated']